import {CUSTOMER_REQUEST, CUSTOMER_REQUEST_FAIL, CUSTOMER_REQUEST_SUCCESS} from "../utils/ActionTypes";

const INITIAL_STATE = {
    data: [],
    isFetching: false,
    hasError: false,
    errorMessage: "",
    selected: {},
    total: 0,
    rowsPerPage: 15,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case CUSTOMER_REQUEST:
            return ({
                ...state,
                isFetching: true,
                hasError: false,
                data: []
            });
        case CUSTOMER_REQUEST_SUCCESS :
            //console.log("total",action)
            return ({
                ...state,
                isFetching: false,
                hasError: false,
                data: action.payload.records,
                total: action.payload.total,
            });
        case CUSTOMER_REQUEST_FAIL:
            return ({
                ...state,
                isFetching: false,
                hasError: true,
                errorMessage: action.payload.response,
            });

        default :
            return state;

    }
}